import {
  BooleanField,
  DependencyFunction,
  IModelContext,
  ModelDependency,
  ModelGroup,
  ModelItemOptions,
  requiredValueOptionsValidation,
  ValueOptions
} from '@mng/model';
import { AngebotMetaData } from '../../../antrag.model.types';

export const options = [
  { name: 'Anlegerprofil herunterladen', value: true },
  { name: 'weiter ohne Anlegerprofil', value: false }
];

export const valueOptions: ValueOptions = new ValueOptions(options);

export function createAnlegerprofilModelGroup(): ModelGroup {
  const modelGroup: ModelGroup = new ModelGroup('anlegerprofil', 'Anlegerprofil');

  modelGroup.addItems(
    new BooleanField('pdf', '').withOptions(
      new ModelItemOptions([requiredValueOptionsValidation]).withValueOptions(valueOptions)
    )
  );
  return modelGroup;
}

export const isAnlegerprofilRequired: DependencyFunction = (
  dependency: ModelDependency,
  modelContext: IModelContext
): boolean => {
  const angebotMetaData: AngebotMetaData = modelContext.dataStack[2];
  return angebotMetaData.anlegerprofilDruckbar;
  // return true;
};
